function pad(n, width) {
  return String(n).padStart(width, '0');
}

export function formatDateByPattern(date, pattern) {
  if (!(date instanceof Date) || isNaN(date)) return String(date);
  return String(pattern)
    .replace(/'/g, '')
    .replace(/yyyy/g, date.getFullYear())
    .replace(/yyy/g, pad(date.getFullYear(), 3))
    .replace(/yy/g, pad(date.getFullYear() % 100, 2))
    .replace(/MM/g, pad(date.getMonth() + 1, 2))
    .replace(/dd/g, pad(date.getDate(), 2))
    .replace(/HH/g, pad(date.getHours(), 2))
    .replace(/hh/g, pad(((date.getHours() + 11) % 12) + 1, 2))
    .replace(/mm/g, pad(date.getMinutes(), 2))
    .replace(/ss/g, pad(date.getSeconds(), 2))
    .replace(/SSS/g, pad(date.getMilliseconds(), 3));
}

function valueToString(value, format) {
  if (value instanceof Date && !isNaN(value)) {
    if (format?.datePattern) return formatDateByPattern(value, format.datePattern);
    return value.toISOString();
  }
  return String(value);
}

export function validateFormat(value, format) {
  if (!format) return { valid: true };
  if (value === null || value === undefined || value === '') return { valid: true };
  const str = valueToString(value, format);

  if (format.lengthMin != null && str.length < format.lengthMin) {
    return { valid: false, code: 'LENGTH_MIN', expected: format.lengthMin, actual: str.length };
  }
  if (format.lengthMax != null && str.length > format.lengthMax) {
    return { valid: false, code: 'LENGTH_MAX', expected: format.lengthMax, actual: str.length };
  }
  if (format.regExp) {
    const re = compileRegex(format.regExp);
    if (!re) {
      return { valid: false, code: 'REGEXP_INVALID', expected: format.regExp };
    }
    if (!re.test(str)) {
      return { valid: false, code: 'REGEXP', expected: format.datePattern || format.regExp, actual: str };
    }
  }
  return { valid: true };
}

// Ancorada a tot el valor, com String.matches() de Java a Sherpa: «a@b.com.» no passa
// una regex d'email sense ^…$ (en JS, test() la donaria per bona en trobar «a@b.com»).
export function compileRegex(rawPattern) {
  const pattern = `^(?:${rawPattern})$`;
  const needsUnicode = /\\[pP]\{/.test(pattern);
  if (needsUnicode) {
    try {
      return new RegExp(pattern, 'u');
    } catch {
      const sanitized = pattern.replace(/\\(["'/])/g, '$1');
      try {
        return new RegExp(sanitized, 'u');
      } catch {
        return null;
      }
    }
  }
  try {
    return new RegExp(pattern);
  } catch {
    return null;
  }
}
